export default __webpack_public_path__ + "static/media/darkWallets.32c017e1.png";